export enum NotificationEvent {
  SetShowNotification = "SetShowNotification",
}
